import decimal2hex from './decimal-to-hex';
import hex2decimal from './hex-to-decimal';
import hex2hsl from './hex-to-hsl';
import hex2rgb from './hex-to-rgb';
import hsb2hsl from './hsb-to-hsl';
import hsb2rgb from './hsb-to-rgb';
import hsl2hsb from './hsl-to-hsb';
import hsl2hex from './hsl-to-hex';
import hsl2rgb from './hsl-to-rgb';
import lab2lch from './lab-to-lch';
import lab2xyz from './lab-to-xyz';
import lch2lab from './lch-to-lab';
import rgb2hex from './rgb-to-hex';
import rgb2hsb from './rgb-to-hsb';
import rgb2hsl from './rgb-to-hsl';
import rgb2xyz from './rgb-to-xyz';
import xyz2lab from './xyz-to-lab';
import xyz2rgb from './xyz-to-rgb';

export default {
  decimal2hex,
  hex2decimal,
  hex2hsl,
  hex2rgb,
  hsb2hsl,
  hsb2rgb,
  hsl2hex,
  hsl2hsb,
  hsl2rgb,
  lab2lch,
  lab2xyz,
  lch2lab,
  rgb2hex,
  rgb2hsb,
  rgb2hsl,
  rgb2xyz,
  xyz2lab,
  xyz2rgb,
};
